import * as React from 'react';
import './add.scss';
import { Col, message, Row, Spin, Switch, Upload, UploadProps } from 'antd';
import { Select } from 'components/select/select';
import { useLocation, useNavigate } from 'react-router-dom';
import TextArea from 'antd/lib/input/TextArea';
import { RcFile, UploadFile } from 'antd/lib/upload';
import { UploadChangeParam } from 'antd/es/upload';
import { DefaultOptionType } from 'antd/es/select';
import { AddPopUp } from '../../../../../core/domain/popups/popups';
import { faNumToEnNum, IsNumeric } from '../../../../../core/utils/decimalExtentions';
import { Input, inputType } from '../../../../../components/input/input';
import { Button } from '../../../../../components';
import { buttonType } from '../../../../../components/button/button';
import { addPopUp } from '../../../../../core/repositories/popups';
import { getAllLevelsAsSelectOption } from 'core/repositories/level';
import { getTransactionPlatforms } from 'core/repositories/transaction';
import { Enum } from 'core/domain/commons/common';

export const CreatePopUp: React.FC = () => {
    // States
    const [isCardLoading, setIsCardLoading] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [popup, setPopUp] = React.useState<AddPopUp>();
    const [levels, setLevels] = React.useState<DefaultOptionType[]>([]);
    const [selectedOptions, setSelectedOptions] = React.useState<DefaultOptionType[]>([]);
    const [platforms, setPlatforms] = React.useState<Enum[]>([]);

    const location = useLocation();

    React.useEffect(() => {
        levels.length === 0 && getAllLevelsAsSelectOption(setIsCardLoading, setLevels);
        // گزینه‌ی «همه پلتفرم ها» (id: -1) را خود getTransactionPlatforms اضافه می‌کند
        platforms.length === 0 && getTransactionPlatforms(() => {}, setPlatforms);
    }, []);

    const URL = window.location;
    var urlSections = URL.pathname.split('/');
    const navigate = useNavigate();

    const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            setPopUp({
                ...popup,
                file: info.file.originFileObj,
            });
        }
    };

    const onNumberChange = (value: string, field: string) => {
        if (value !== '') {
            value = faNumToEnNum(value);
        }

        if (value !== '' && !IsNumeric(faNumToEnNum(value.split('')[value.split('').length - 1]))) {
            return;
        }

        setPopUp({
            ...popup,
            [field]: value,
        });
    };

    const beforeUpload = (file: RcFile) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            message.error('فقط فرمت های mp4 قابل قبول میباشد');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            message.error('حجم عکس باید کمتر از ۲ مگابایت باشد.');
        }

        return setPopUp({
            ...popup,
            file: file,
        });
    };

    const onRemoveFile = (file: UploadFile) => {
        setPopUp({
            ...popup,
            file: undefined,
        });
    };

    return (
        <>
            <Spin spinning={isCardLoading} tip="درحال بارگذاری">
                <div className="pmx-add-popup">
                    <h3>افزودن پاپ آپ</h3>

                    <form>
                        <Row>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="عنوان"
                                    placeholder="عنوان"
                                    name="title"
                                    value={popup?.title}
                                    onChange={(e) =>
                                        setPopUp({
                                            ...popup,
                                            title: e.target.value || '',
                                        })
                                    }
                                />
                            </Col>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="فاصله بین هر نمایش (روز)"
                                    placeholder="فاصله بین هر نمایش (روز)"
                                    name="intervalView"
                                    value={popup?.intervalView}
                                    onChange={(e) => onNumberChange(e.target.value, 'intervalView')}
                                    maxLength={10}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="لینک شدن به صفحه"
                                    placeholder="لینک شدن به صفحه"
                                    name="linkTo"
                                    value={popup?.linkTo}
                                    onChange={(e) =>
                                        setPopUp({
                                            ...popup,
                                            linkTo: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="نمایش در صفحه"
                                    placeholder="نمایش در صفحه"
                                    name="urlPage"
                                    value={popup?.urlPage}
                                    onChange={(e) =>
                                        setPopUp({
                                            ...popup,
                                            urlPage: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            {levels.length != 0 && (
                                <div className="select">
                                    <label htmlFor="">سطح‌های مورد نمایش</label>
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        value={selectedOptions}
                                        placeholder="انتخاب کنید"
                                        onChange={(value, options) => {
                                            let mapOptions = options.map((i: DefaultOptionType) => ({
                                                value: i.value,
                                                label: i.label,
                                            }));
                                            setSelectedOptions(mapOptions);
                                        }}
                                        defaultValue={selectedOptions}
                                        options={levels}
                                    />
                                </div>
                            )}
                        </Row>
                        <Row>
                            {platforms.length !== 0 && (
                                <div className="select">
                                    <label htmlFor="">پلتفرم نمایش</label>
                                    <Select
                                        value={popup?.platform ?? -1}
                                        onChange={(value) => setPopUp({ ...popup, platform: value })}
                                        options={platforms.map((platform) => ({
                                            value: platform.id,
                                            label: platform.title,
                                        }))}
                                    />
                                </div>
                            )}
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="نمایش بعد از (ثانیه)"
                                    placeholder="نمایش بعد از (ثانیه)"
                                    name="viewAfterSecond"
                                    value={popup?.viewAfterSecond}
                                    onChange={(e) => onNumberChange(e.target.value, 'viewAfterSecond')}
                                    maxLength={10}
                                />
                            </Col>
                            <Col>
                                <Input
                                    type={inputType.text}
                                    label="تعداد نمایش"
                                    placeholder="تعداد نمایش"
                                    name="viewCount"
                                    value={popup?.viewCount}
                                    maxLength={10}
                                    onChange={(e) => onNumberChange(e.target.value, 'viewCount')}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <div className="textarea">
                                <label htmlFor="description">توضیحات</label>
                                <TextArea
                                    name="description"
                                    value={popup?.description}
                                    onChange={(e) => setPopUp({ ...popup, description: e.target.value })}
                                />
                            </div>
                        </Row>
                        <Row>
                            <div className="browse-field">
                                <label htmlFor="documents-photo">تصویر</label>

                                <div id="documents-photo" className="browse">
                                    <Upload
                                        onPreview={() => null}
                                        name="avatar"
                                        listType="text"
                                        className="file-uploader"
                                        showUploadList
                                        beforeUpload={beforeUpload}
                                        onChange={handleChange}
                                        onRemove={onRemoveFile}
                                    >
                                        <button onClick={(el) => el.preventDefault()}>آپلود فایل</button>
                                    </Upload>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <label htmlFor="documents-photo">وضعیت</label>

                            <Switch
                                checked={popup?.isActive}
                                checkedChildren={'فعال'}
                                unCheckedChildren={'غیر فعال'}
                                onChange={(checked) =>
                                    setPopUp({
                                        ...popup,
                                        isActive: checked,
                                    })
                                }
                            />
                        </Row>

                        <div className="buttons">
                            <Button
                                htmlType="button"
                                type={buttonType.info}
                                text="افزودن"
                                onClick={() => {
                                    addPopUp(setLoading, popup, selectedOptions, () => navigate('/dashboard/popups'));
                                }}
                                loading={loading}
                            />

                            <Button
                                htmlType="button"
                                type={buttonType.outlined}
                                text="بازگشت"
                                onClick={() => navigate(-1)}
                            />
                        </div>
                    </form>
                </div>
            </Spin>
        </>
    );
};
